import { chakra } from '@chakra-ui/react';

interface PageContentProps {
  url: string
}

const Iframe = chakra('iframe');

export default function PageContent({ url }: PageContentProps) {
  //const [content, setContent] = useState('');

  // useEffect(() => {
  //   axios.get(url).then(({ data }) => setContent(data))
  // }, []);
  
  // return (
  //   <div dangerouslySetInnerHTML={{
  //     __html: content
  //   }} />
  // )
  return (
    <Iframe w="full" h="800px" src={url} />
  )
}
